import React, { useState } from 'react'
import { Button } from '@telavita-core/react-design-kit'

import ModalGeneric from '../ModalGeneric'
import { TherapyApproachModal } from '../TherapyApproachModal'
import {
  ProfessionalGenderFilter,
  ProfessionalTherapyApproachFilter,
  ProfessionalNameFilter,
  ProfessionalMeetsAgesFilter,
  ProfessionalLanguageFilter,
} from 'components/Filters'
import LineSeparator from 'components/LineSeparator'

import { ReactComponent as ClearIcon } from 'static/svg/clear-icon.svg'

import { MoreFiltersModalProps, ModalFooterProps } from './MoreFiltersModal.types'
import { useMoreFilters } from './hooks/useMoreFilters'

import * as S from './styles'

const ModalFooter = ({
  onClearFilters, 
  shouldDisableClearFilterButton, 
  handleApplyFilters
}: ModalFooterProps) => (
  <S.ModalFooter>
    <Button
      variant='text'
      onClick={onClearFilters}
      customClassName='clearFiltersButton'
      uppercase={false}
      disabled={shouldDisableClearFilterButton}
    >
      <ClearIcon />
      limpar filtros
    </Button>

    <Button
      variant='contained'
      onClick={handleApplyFilters}
      customClassName='applyFiltersButton'
      uppercase
    >
      Aplicar
    </Button>
  </S.ModalFooter>
)

export const MoreFiltersModal: React.FC<MoreFiltersModalProps> = ({ handleCloseMoreFiltersModal, searchInfo }) => {
  const [showTherapyApproachModal, setShowTherapyApproachModal] = useState(false)

  const {
    approaches,
    clearNameTermError,
    handleApplyFilters,
    onChangeApproach,
    onChangeGender,
    onClearFilters,
    selectedApproach,
    selectedGender,
    onChangeProfessionalNameTerm,
    professionalNameTerm,
    professionalNameTermIsToShortError,
    ageRanges,
    onChangeAgeRanges,
    ages,
    onChangeAges,
    ageRangeCategoryAdolescentError,
    ageRangeCategoryKidError,
    onChangeAgeRangeCategoryAdolescentError,
    onChangeAgeRangeCategoryKidError,
    selectedLanguages,
    onChangeSelectedLanguages,
    shouldDisableClearFilterButton
  } = useMoreFilters({ handleCloseMoreFiltersModal })
  
  return (
    <div>
      <ModalGeneric
        modalTitle='Mais filtros'
        onCloseModal={handleCloseMoreFiltersModal}
        footerActions={
          <ModalFooter 
            handleApplyFilters={handleApplyFilters} 
            onClearFilters={onClearFilters}
            shouldDisableClearFilterButton={shouldDisableClearFilterButton}
          />
        }
      >
        
        <ProfessionalNameFilter
          onChangeProfessionalNameTerm={onChangeProfessionalNameTerm}
          professionalNameTerm={professionalNameTerm}
          hasError={professionalNameTermIsToShortError}
          clearFieldError={clearNameTermError}
          searchInfo={searchInfo}
        />
        
        <LineSeparator 
          lineColor="#e2e2e2"
          lineHeight="1px"
          lineMargin="30px 0"
          lineWidth="100%"
        />

        <ProfessionalGenderFilter
          selectedGender={selectedGender}
          onChangeGender={onChangeGender}
        />

        <ProfessionalTherapyApproachFilter
          approaches={approaches}
          selectedApproach={selectedApproach}
          onChangeApproach={onChangeApproach}
          openTherapyApproachModal={() => setShowTherapyApproachModal(true)}
        />

        <ProfessionalMeetsAgesFilter
          ageRanges={ageRanges}
          onChangeAgeRanges={onChangeAgeRanges}
          ages={ages}
          onChangeAges={onChangeAges}
          ageRangeCategoryAdolescentError={ageRangeCategoryAdolescentError}
          ageRangeCategoryKidError={ageRangeCategoryKidError}
          onChangeAgeRangeCategoryAdolescentError={onChangeAgeRangeCategoryAdolescentError}
          onChangeAgeRangeCategoryKidError={onChangeAgeRangeCategoryKidError}
        />

        <ProfessionalLanguageFilter
          selectedLanguages={selectedLanguages}
          onChangeSelectedLanguages={onChangeSelectedLanguages}
        />
        
      </ModalGeneric>

      {showTherapyApproachModal
        ? <TherapyApproachModal onClose={() => setShowTherapyApproachModal(false)}/>
        : null
      }
    </div>
  )
}